import { render, staticRenderFns } from "./VuesticSlider.vue?vue&type=template&id=fc636ae2&"
import script from "./VuesticSlider.vue?vue&type=script&lang=js&"
export * from "./VuesticSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports